<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive }
    ]"
  >
    <nprogress-container></nprogress-container>
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{ name: 'Dashboard', icon: 'dashboard', path: '/dashboard' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="
            hasScope('users:manage') ||
              hasScope('roles:manage') ||
              hasScope('drivers:field_groups:manage')
          "
          :link="{
            name: 'Gebruikers',
            icon: 'people'
          }"
        >
          <sidebar-item
            v-if="hasScope('users:manage')"
            :link="{ name: 'Actieve Gebruikers', path: '/users/overview' }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('users:manage')"
            :link="{ name: 'Gebruiker Toevoegen', path: '/users/add' }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('users:manage')"
            :link="{
              name: 'Verwijderde Gebruikers',
              path: '/users/overview/deleted'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('roles:manage')"
            :link="{
              name: 'Gebruikersrollen',
              path: '/user_roles/overview'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('roles:manage')"
            :link="{ name: 'Gebruikersrol Toevoegen', path: '/user_roles/add' }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('drivers:field_groups:manage')"
            :link="{
              name: 'Veld groepen',
              path: '/user_field_groups/overview'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('drivers:field_groups:manage')"
            :link="{
              name: 'Veld groep Toevoegen',
              path: '/user_field_groups/add'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('drivers:field_groups:manage')"
            :link="{
              name: 'Veld type opties',
              path: '/user_field_types/type/options'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('drivers:manage')"
          :link="{
            name: 'Chauffeurs',
            icon: '/img/icons/driver.svg'
          }"
        >
          <sidebar-item
            :link="{ name: 'Chauffeurs overzicht', path: '/drivers/overview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Chauffeur Toevoegen', path: '/drivers/add' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Chauffeur velden',
              path: '/drivers/group/overview'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('drivers:traveling_expenses:export')"
            :link="{
              name: 'Chauffeur onkosten',
              path: '/drivers/expenses'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('import:view') || hasScope('import:manage')"
            :link="{
              name: 'Import overzicht',
              path: '/drivers/imports/overview'
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasScope('import:manage')"
            :link="{
              name: 'Import Toevoegen',
              path: '/drivers/imports/add'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('schedule:manage')"
          :link="{
            name: 'Roosters',
            icon: 'schedule'
          }"
        >
          <sidebar-item
            :link="{ name: 'Rooster overzicht', path: '/schedules/overview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Rooster Toevoegen', path: '/schedules/add' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Beschikbaarheid chauffeurs',
              path: '/schedules/report/drivers-availability'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Overzicht diensten',
              path: '/schedules/report/drivers-scheduled-shifts'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Laaste keer ingeroosterd',
              path: '/schedules/report/drivers-last-scheduled'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('routes:manage')"
          :link="{ name: 'Routes', icon: 'directions_bus' }"
        >
          <sidebar-item
            :link="{ name: 'Routes overzicht', path: '/routes/overview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Route Toevoegen', path: '/routes/add' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('shifts:manage')"
          :link="{ name: 'Diensten', icon: 'departure_board' }"
        >
          <sidebar-item
            :link="{ name: 'Diensten overzicht', path: '/shifts/overview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Dienst Toevoegen', path: '/shifts/add' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('notifications:log:mail:view')"
          :link="{ name: 'Notificaties', icon: 'notifications_active' }"
        >
          <sidebar-item
            :link="{ name: 'E-mail log', path: '/notifications/mail-log' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="hasScope('national_holidays:manage')"
          :link="{ name: 'Feestdagen', icon: '/img/icons/holiday.svg' }"
        >
          <sidebar-item
            :link="{ name: 'Feestdagen overzicht', path: '/holidays/overview' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Feestdag Toevoegen', path: '/holidays/add' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Pages', icon: 'image' }"
        >
          <sidebar-item
            :link="{ name: 'Pricing', path: '/pricing' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'RTL Support', path: '/pages/rtl' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Timeline', path: '/pages/timeline' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Login', path: '/login' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Register', path: '/register' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Lock Screen', path: '/lock' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'User Profile', path: '/pages/user' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Components', icon: 'apps' }"
        >
          <sidebar-item
            :link="{ name: 'Buttons', path: '/components/buttons' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Grid System', path: '/components/grid-system' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Panels', path: '/components/panels' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Sweet Alert', path: '/components/sweet-alert' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Notifications', path: '/components/notifications' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Icons', path: '/components/icons' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Typography', path: '/components/typography' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Forms', icon: 'content_paste' }"
        >
          <sidebar-item
            :link="{ name: 'Regular Forms', path: '/forms/regular' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Extended Forms', path: '/forms/extended' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Validation Forms', path: '/forms/validation' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Wizard', path: '/forms/wizard' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Tables', icon: 'grid_on' }"
        >
          <sidebar-item
            :link="{ name: 'Regular Tables', path: '/table-list/regular' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Extended Tables', path: '/table-list/extended' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Paginated Tables', path: '/table-list/paginated' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Maps', icon: 'place' }"
        >
          <sidebar-item
            :link="{ name: 'Google Maps', path: '/maps/google' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Full Screen Maps', path: '/maps/full-screen' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Vector Maps', path: '/maps/vector-map' }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Widgets', icon: 'widgets', path: '/widgets' }"
        ></sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Charts', icon: 'timeline', path: '/charts' }"
        ></sidebar-item>
        <sidebar-item
          v-if="showDemoComponents()"
          :link="{ name: 'Calendar', icon: 'date_range', path: '/calendar' }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <build-number-check></build-number-check>
      <o-auth-auto-refresh></o-auth-auto-refresh>
      <top-navbar></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import NprogressContainer from "vue-nprogress/src/NprogressContainer";
import BuildNumberCheck from "../BuildNumberCheck.vue";
import OAuthAutoRefresh from "../OAuthAutoRefresh.vue";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`, {
      wheelSpeed: 1
    });
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    // initScrollbar("main-panel");

    docClasses.remove("perfect-scrollbar-on");
    docClasses.remove("perfect-scrollbar-off");
    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.remove("perfect-scrollbar-on");
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
    NprogressContainer,
    BuildNumberCheck,
    OAuthAutoRefresh
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      sidebarBackgroundImage: "",
      sidebarMini: true,
      sidebarImg: true
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    hasScope(scope) {
      let scopes = localStorage.getItem("user_scopes");
      scopes = scopes.split(",");

      if (scopes.indexOf("admin") !== -1) {
        return true;
      }

      return scopes.indexOf(scope) !== -1;
    },
    showDemoComponents() {
      return process.env.NODE_ENV !== "production";
    }
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

div.nprogress-container {
  height: 5px;
  position: fixed;
  z-index: 10000;
  width: 100%;

  #nprogress .bar {
    height: 5px;
  }
}
</style>
